import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'

import StepIndicator from '../../components/step-indicator'
import MembershipConfirmation from '../../components/membership-confirmation'
import YourDetails from '../../components/your-details'
import BillingAddress from '../../components/billing-address'
import DayPass from '../../components/day-pass'
import KeepingInTouch from '../../components/keeping-in-touch'
import PrevNext from '../../components/prev-next'

import MembershipFormContext from '../../context/membership'
import initialValues from '../../data/initialValues'
import validation from '../../validation/membership'
import { setSS, getSS, cleanObject, loadIndexPage } from '../../helpers'
import { createMembership, saveMembership, getTitles } from '../../api'

const Details: React.FC = (props: any) => {

  const navigate = useNavigate()
  const params = useParams()
  const membershipForm = useContext(MembershipFormContext)
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const [ dataLayerInitialPush, setDataLayerInitialPush ] = useState(getSS('dataLayerInitialPush'))
  const [ dataLayerInitialPush2, setDataLayerInitialPush2 ] = useState(getSS('dataLayerInitialPush2'))
  const [ details, setDetails ] = useState(initialValues.details)
  const [ titles, setTitles ] = useState({})
  const [ sessionId, setSessionId ] = useState(getSS('membership').session_id)
  const url = membership_form.private_form ? 'private/' + params.url : params.url
  let membership = getSS('membership')

  if (!membership || membership.process_payment) {
    loadIndexPage(navigate, url)
  }

  useEffect(() => {
    document.title = 'Your details - ' + (window as any).KEW.collections.membership_form[0].meta_title
    document.body.classList.remove('hidden')
  })

  useEffect(() => {

    function parseResponseHeaders(headerStr: any) {
      var headers:any = [];
      if (!headerStr) {
        return headers;
      }
      var headerPairs = headerStr.split('\u000d\u000a');
      for (let i = 0; i < headerPairs.length; i++) {
        let headerPair = headerPairs[i];
        var index = headerPair.indexOf(': ');
        if (index > 0) {
          var key = headerPair.substring(0, index);
          var val = headerPair.substring(index + 2);
          headers[key] = val
        }
      }
      return headers;
    }
    if (!sessionId) {
      const d = new Date();
      d.setTime(d.getTime() + 2*60*60*1000);
      const request = new XMLHttpRequest();
      request.open("HEAD", "/admin", true);
      request.send();
      request.onreadystatechange = function() {
        if (this.readyState === this.HEADERS_RECEIVED) {
          const headers = request.getAllResponseHeaders();
          setSessionId(parseResponseHeaders(headers)._sepia_auth_sessionid);
          document.cookie = '_sepia_creator_auth='+ parseResponseHeaders(headers)._sepia_auth_sessiontoken +'; expires=' + d.toUTCString() + '; path=/';
        }
      }
    }

  }, [sessionId])

  useEffect(() => {
    document.body.classList.remove('landing')
    document.body.style.backgroundImage = ''
    membershipForm.preSelectedMembership ? membershipForm.setCurrentStep(1) : membershipForm.setCurrentStep(2)
    if (getSS('details')) {
      setDetails(getSS('details'));
    }

    // if (data.payment_type === 'Single' && membership_form.form_type !== 'upgrade') {
    //   data.amount = data.selected_membership.base_price
    //   data.payment_method = 'Card/PayPal';
    // }
    // if (data.payment_type === 'Regular' && membership_form.form_type !== 'upgrade') {
    //   data.amount = membership.selected_membership.base_price - membership.selected_membership.direct_debit_discount
    //   data.payment_method = 'DirectDebit';
    // }
    // if (membership_form.form_type === 'ingarden') {
    //   if (data.payment_type === 'CardReader') {
    //     data.amount = data.selected_membership.base_price
    //   } else {
    //     data.amount = data.selected_membership.base_price - data.selected_membership.direct_debit_discount
    //   }
    //   console.log(data);
    // }
    const formType = membership_form.form_type === 'standard' ? 'new' :
      membership_form.form_type === 'upgrade' ? 'upgrade' :
      membership_form.form_type === 'renewal' ? 'renewal' :
      membership_form.form_type === 'ingarden' ? 'new' :
      membership_form.form_type === 'daypass' ? 'new' : 'new'

    if (!dataLayerInitialPush) {
      (window as any).dataLayer = (window as any).dataLayer || [];
      (window as any).dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          items: [{
            item_name: `Membership - ${membership_form.name} - ${membership.selected_membership.value}`,
            item_id: `${membership_form.campaigncode}`,
            price: membership.amount,
            item_brand: `${membership.selected_membership.wakehurst_membership ? 'Wakehurst' : 'Kew'}`,
            item_category: `Membership - ${membership.selected_membership.value}`,
            item_category2: `${formType}`,
            quantity: 1
          }]
        }
      });
      setSS('dataLayerInitialPush', true)
      setDataLayerInitialPush(true)
    }

  }, [dataLayerInitialPush, membership.payment_type, membership.selected_membership.base_price, membership.selected_membership.direct_debit_discount, membership.selected_membership.value, membership.selected_membership.wakehurst_membership, membershipForm, membership_form.campaigncode, membership_form.form_type, membership_form.name, membership.amount])

  useEffect(() => {
    const loadTitles = async () => {
      let titles = await getTitles()
      setTitles(titles)
    }
    loadTitles()
  }, [])

  const onSubmit = async (data: any) => {

    if (membership.selected_membership.value === 'indfriend' || membership.selected_membership.value === 'indfamfriend' || membership.selected_membership.value === 'wakehurst_indfriend' || membership.selected_membership.value === 'wakehurst_indfamfriend' || membership.selected_membership.value === 'youngpersons') {
      data.second_named_adult_email = ''
      data.second_named_adult_first_name = ''
      data.second_named_adult_last_name = ''
      data.second_named_adult_phone = ''
      data.second_named_adult_salutation = ''
      membership.second_named_adult_email = ''
      membership.second_named_adult_first_name = ''
      membership.second_named_adult_last_name = ''
      membership.second_named_adult_phone = ''
      membership.second_named_adult_salutation = ''
      setSS('membership', membership)
    }

    console.log(data);
    membershipForm.showLoading()
    setSS('details', data)
    data = { ...data, ...membership }

    // shape data
    delete data.address_search
    delete data.selected_membership_control
    delete data.ticketPurchasedAt
    delete data.upgrade_options
    // phone & post are opt outs

    data.session_id = sessionId
    data.optins_phone = !data.optins_phone
    data.optins_post = !data.optins_post
    data.optins_second_adult_phone = !data.optins_second_adult_phone
    data.optins_second_adult_post = !data.optins_second_adult_post

    if (!data.public_id) { // handle initial creation
      const createdMembership: any = await createMembership(data)
      console.log(createdMembership)
      if (createdMembership?.status !== 201) {
        alert('something went wrong creating the membership!')
        return
      }
      data = createdMembership.data
      console.log(data);
    }

    // save with process_payment set to false (this generates a new payment_token for braintree)
    data.process_payment = false
    const savedMembership: any = await saveMembership(data)
    if (savedMembership?.status === 200) {
      data = savedMembership.data
      setSS('membership', data);

      // GTM data
      if (!dataLayerInitialPush2) {
        const formType = membership_form.form_type === 'standard' ? 'new' :
          membership_form.form_type === 'upgrade' ? 'upgrade' :
          membership_form.form_type === 'renewal' ? 'renewal' :
          membership_form.form_type === 'ingarden' ? 'new' :
          membership_form.form_type === 'daypass' ? 'new' : 'new';

        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({
          event: 'add_shipping_info',
          ecommerce: {
            shipping_tier: 'online',
            items: [{
              item_name: `Membership - ${membership_form.name} - ${membership.selected_membership.value}`,
              item_id: `${membership_form.campaigncode}`,
              price: membership.amount,
              item_brand: `${membership.selected_membership.wakehurst_membership ? 'Wakehurst' : 'Kew'}`,
              item_category: `Membership - ${membership.selected_membership.value}`,
              item_category2: `${formType}`,
              quantity: 1
            }]
          }
        });
        setSS('dataLayerInitialPush2', true)
        setDataLayerInitialPush2(true)
      }
      membershipForm.hideLoading()
      navigate(`/membership/${url}/payment`)
    } else {
      alert('something went wrong creating the membership!')
      membershipForm.hideLoading()
      return
    }

  }

  return (
    <>
      { membership &&
        <>
          <Formik
            initialValues={ details }
            validationSchema={ validation.details }
            enableReinitialize={true}
            onSubmit={ onSubmit }>
              {(props: any) => {
                props.errors = cleanObject(props.errors)
                return (
                  <>
                    <Form name="membershipForm">
                      <StepIndicator />
                      { membershipForm.preSelectedMembership &&
                        <MembershipConfirmation />
                      }
                      <YourDetails {...props} titles={titles} />
                      <BillingAddress {...props} />
                      { membership_form.form_type === 'daypass' &&
                        <DayPass {...props} />
                      }
                      <KeepingInTouch {...props} />
                      <PrevNext navigate={navigate} />
                    </Form>
                  </>
                )}
              }
          </Formik>
        </>
      }
    </>
  )
}

export default Details